// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6042":"1393ba7f8a58bbec","8346":"18fae77685c0b859"}[chunkId] + ".css";
};